import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { getTodayISO } from "@/lib/dateUtils";

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
}

export function DateRangeFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: DateRangeFilterProps) {
  const today = getTodayISO();

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-foreground">Date Range</h3>
      <div className="space-y-2">
        <div className="space-y-1">
          <Label className="text-xs text-muted-foreground">From</Label>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            min={today}
            className="text-sm"
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-muted-foreground">To</Label>
          <Input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            min={startDate || today}
            className="text-sm"
          />
        </div>
      </div>
      {(startDate || endDate) && (
        <button
          onClick={() => {
            onStartDateChange("");
            onEndDateChange("");
          }}
          className="text-xs text-muted-foreground hover:text-foreground transition-colors"
        >
          Clear dates
        </button>
      )}
    </div>
  );
}
